var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1310_4532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6819 15.2101V15.2083C15.5857 15.2153 15.0896 15.2451 13.9827 15.2451C13.0989 15.2451 12.4768 15.2188 12.2581 15.2083V15.2109C8.85607 15.0613 6.31682 14.4689 6.31682 13.7602C6.31682 13.0523 8.85607 12.4599 12.2581 12.3077V14.6212C12.4803 14.6369 13.1173 14.6746 13.9976 14.6746C15.0537 14.6746 15.5831 14.6308 15.6819 14.6221V12.3094C19.0769 12.4608 21.6101 13.0532 21.6101 13.7602C21.6101 14.4689 19.0769 15.0596 15.6819 15.2101ZM15.6819 12.0688V9.99855H20.4192V6.84155H7.52082V9.99855H12.2581V12.0679C8.40807 12.2447 5.5127 13.0077 5.5127 13.9212C5.5127 14.8347 8.40807 15.5968 12.2581 15.7744V22.4087H15.6819V15.7727C19.5258 15.5959 22.4142 14.8338 22.4142 13.9212C22.4142 13.0086 19.5258 12.2464 15.6819 12.0688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1310_4532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThether);
export default __webpack_public_path__ + "static/media/thether.190f722983d336dc14aa713ee743e5aa.svg";
export { ForwardRef as ReactComponent };